<template>
  <v-dialog v-model="dialog" width="650" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon>person</v-icon> Editar usuario
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0">
            <h4>Datos de usuario</h4>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Nombre de usuario"
                  prepend-icon="person"
                  v-model="form.nombre_usuario"
                  maxlength="50"
                  autocomplete="off"
                  :rules="$validate(['required'])"
                  required
                  autofocus
                  disabled
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="Correo electrónico"
                  v-model="form.correo"
                  maxlength="100"
                  prepend-icon="email"
                  :rules="$validate(['required'])"
                  required
                  disabled
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  :items="sistemas"
                  label="Elija el sistema para obtener los roles"
                  item-text="descripcion"
                  item-value="id"
                  @change="getRoles"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  multiple
                  chips
                  :items="roles"
                  v-model="values"
                  label="Roles"
                  item-text="descripcion"
                  item-value="id"
                  :rules="$validate(['required'])"
                  required
                  return-object
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <!-- <small class="error--text text-required">* Los campos son obligatorios</small> -->
          <v-spacer></v-spacer>
          <v-btn @click="close()"
            ><v-icon>cancel</v-icon> {{ $t("common.cancel") }}</v-btn
          >
          <v-btn color="primary" type="submit" :loading="loading"
            ><v-icon>check</v-icon> {{ $t("common.save") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item"],
  data() {
    return {
      dialog: false,
      valid: false,
      form: {
        nombre_usuario: "",
        correo: ""
      },
      id: null,
      roles: [],
      sistemas: [],
      values: [],
      loading: false,
	  user:this.$storage.getUser(),
	  siglas_sistemas:[],
    };
  },
  mounted() {
	this.cargarSistemas()
    this.obtenerSistemas();
    this.getRoles();
    this.$bus.$on("openDialogEditarUsuario", item => {
      item.roles.forEach(elem => {
        this.values.push(elem);
      });
      this.form.nombre_usuario = item.nombre_usuario;
      this.form.correo = item.correo;
      this.id = item.id;
      this.dialog = true;
    });
  },
  methods: {
	cargarSistemas(){
		let roles = this.user.roles
		roles.forEach(element => {
			if(parseInt(element.id) == 86){
				this.siglas_sistemas.push("RRHH")
			}
			if(parseInt(element.id) == 43){
				this.siglas_sistemas.push("SICOBS")
			}
		});
	},
    async obtenerSistemas() {
      try {
        this.loading = true;
		let siglas=this.siglas_sistemas.join(",")
        let res = await this.$service.graphql({
          query: `
			query{
				sistemas(descripcion:"${siglas}"){
					rows{
						id
						descripcion
					}
				}
			}
		`
        });
        this.sistemas = res.sistemas.rows;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getRoles() {
      try {
        let res = await this.$service.graphql({
          query: `
			query {
				roles{
					rows {
						id
						id_sistema
						descripcion
					}
				}
			}
		`
        });
        this.roles = this.formatearListadoRoles(res.roles.rows);
      } catch (error) {
        console.log(error);
      }
    },
    formatearListadoRoles(roles) {
      const data = [];
      this.sistemas.forEach(({ id, descripcion }) => {
        data.push({ header: descripcion });
        roles.forEach(rol => {
          if (parseInt(id) === parseInt(rol.id_sistema)) data.push(rol);
        });
      });

      return data;
    },
    close() {
      this.dialog = false;
      this.form = {
        nombre_usuario: "",
        correo: ""
      };
      this.values = [];
      this.valid = false;
      this.loading = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.form.roles = this.values;
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $usuario: EditUsuario!) {
              usuarioEdit(id: $id, usuario: $usuario) {
                id
              }
            }
          `,
          variables: {
            id: this.id,
            usuario: this.form
          }
        });
        this.$message.success();
        this.loading = false;
        this.$bus.$emit("closeDialog");
        this.close();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/usuario_sistema/dialogs/EditarUsuario.vue